import "style.css"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomePage from "pages/HomePage"
import Faq from "pages/Faq";
import PrivacyPolicy from "pages/PrivacyPolicy";
import TermsOfService from "pages/TermsOfService";
import AboutUs from "pages/AboutUs";
import OurAnalyses from "pages/OurAnalyses";
import Charts from "pages/Charts";
import {useSelector} from "react-redux";

function App() {
  const locale = useSelector(state => state.locale);
  if(locale ==='ar'){
    return (
        <div dir="rtl">
          <Router>
            <Switch>
              <Route path="/chart">
                <Charts />
              </Route>
              <Route path="/our-analyses">
                <OurAnalyses />
              </Route>
              <Route path="/about-us">
                <AboutUs />
              </Route>
              <Route path="/privacy-policy">
                <PrivacyPolicy />
              </Route>
              <Route path="/terms-and-condition">
                <TermsOfService />
              </Route>
              <Route path="/faq">
                <Faq />
              </Route>
              <Route path="/">
                <HomePage />
              </Route>
            </Switch>
          </Router>
        </div>
    );
  }
  else{
    return (
          <Router>
            <Switch>
              <Route path="/chart">
                <Charts />
              </Route>
              <Route path="/our-analyses">
                <OurAnalyses />
              </Route>
              <Route path="/about-us">
                <AboutUs />
              </Route>
              <Route path="/privacy-policy">
                <PrivacyPolicy />
              </Route>
              <Route path="/terms-and-condition">
                <TermsOfService />
              </Route>
              <Route path="/faq">
                <Faq />
              </Route>
              <Route path="/">
                <HomePage />
              </Route>
            </Switch>
          </Router>
    );
  }
}
export default App
